import { FlexRow } from '@/components/common/Flex';
import FinancialEntityRelinkButton from '@/components/financialEntities/FinancialEntityRelinkButton';
import FinancialEntityWithMask from '@/components/financialEntities/FinancialEntityWithMask';
import { ExternalFinancialEntity } from '@common/financialEntities';
import Banner, { BannerProps } from '../common/Banner';
import { LinkBroken01 } from '../common/icons';
import { FinancialEntityIcon } from '../financialEntities/FinancialEntityIcon';

export interface FinancialInstitutionRelinkWarningProps
    extends Omit<BannerProps, 'children'> {
    institutionName: string;
    accounts: ExternalFinancialEntity[];
}

export default function FinancialInstitutionRelinkWarning({
    institutionName,
    accounts,
    ...props
}: FinancialInstitutionRelinkWarningProps) {
    const primaryAccount = accounts[0];
    const additionalAccountsCount = accounts.length - 1;

    return (
        <Banner
            mt={4}
            icon={
                <FlexRow alignItems="center" gap={2}>
                    <FinancialEntityIcon fe={primaryAccount} w={6} h={6} />
                    <LinkBroken01 color="black" />
                </FlexRow>
            }
            button={
                <FinancialEntityRelinkButton
                    account={primaryAccount}
                    title="Reconnect"
                />
            }
            {...props}
        >
            <>
                <FinancialEntityWithMask fe={primaryAccount} mr={1} />
                {` and ${additionalAccountsCount} other ${institutionName} account${additionalAccountsCount > 1 ? 's' : ''} need to be reconnected`}
            </>
        </Banner>
    );
}
